module.exports = require("ms");